// extracted by mini-css-extract-plugin
export var backdrop = "ShellNavDrawer-module--backdrop--026d7";
export var body = "ShellNavDrawer-module--body--5447b";
export var close = "ShellNavDrawer-module--close--7a709";
export var header = "ShellNavDrawer-module--header--dabe3";
export var panel = "ShellNavDrawer-module--panel--97713";
export var useApp = "ShellNavDrawer-module--useApp--84c9e";